
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import React, { useState, useEffect, useRef } from 'react';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { FloatLabel } from 'primereact/floatlabel';
import moment from 'moment';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const AddEditShiftMasterDialog = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [shiftStart, setShiftStart] = useState(null);
    const [shiftEnd, setShiftEnd] = useState(null);
    const [shiftName, setShiftName] = useState('');
    const [shiftNameErrText, setShiftNameErrText] = useState('');
    const [shiftNameErr, setShiftNameErr] = useState(false);
    const [shiftStartErrText, setShiftStartErrText] = useState('');
    const [shiftStartErr, setShiftStartErr] = useState(false);
    const [shiftEndErrText, setShiftEndErrText] = useState('');
    const [shiftEndErr, setShiftEndErr] = useState(false);

    const submitButtonRef = useRef(null);
    const shiftNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        // if (props.ID) {
        //     shiftNameRef(props?.masterData?.shiftName);
        // }

        // Ensure focus after modal renders
        setTimeout(() => {
            shiftNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                Loader.show();
                const loginData = CommonConfig.loginData();
                setSecurityUserID(loginData?._id);
                if (props.ID) {
                    setShiftName(props?.masterData?.ShiftName);
                    setShiftStart(props?.masterData?.ShiftStart ? new Date(props?.masterData?.ShiftStart) : null);
                    setShiftEnd(props?.masterData?.ShiftEnd ? new Date(props?.masterData?.ShiftEnd) : null);
                }
                Loader.hide();
            } catch (error) {
                Loader.hide();
                console.error('Error in useEffect:', error);
            }
        };
        fetchData();
    }, []);

    const onCancel = () => {
        props.onCancel();
    }

    const normalizeTime = (date) => {
        if (!date) return null;
        const d = new Date(date);
        d.setFullYear(1970, 0, 1);
        d.setSeconds(0);
        d.setMilliseconds(0);
        return d;
    };

    const handleStartChange = (value) => {
        const endTime = shiftEnd;
        const normStart = normalizeTime(value);
        const normEnd = normalizeTime(endTime);
        if (normStart) {
            if (normEnd && normStart > normEnd) {
                setShiftStartErr(true);
                setShiftStartErrText("'Start' time cannot be later than 'End' time.");
            } else if (normEnd && normStart.getTime() === normEnd.getTime()) {
                setShiftStartErr(true);
                setShiftStartErrText("'Start' time cannot be the same as 'End' time.");
            } else {
                setShiftStartErr(false);
                setShiftStartErrText("");
            }
        }

        setShiftStart(value);
    };

    const handleEndChange = (value) => {
        const startTime = shiftStart;
        const normEnd = normalizeTime(value);
        const normStart = normalizeTime(startTime);
        if (normEnd) {
            if (normStart && normEnd < normStart) {
                setShiftEndErr(true);
                setShiftEndErrText("'End' time cannot be earlier than 'Start' time");
            } else if (normStart && normEnd.getTime() === normStart.getTime()) {
                setShiftEndErr(true);
                setShiftEndErrText("'End' time cannot be the same as 'Start' time.");
            } else {
                setShiftEndErr(false);
                setShiftEndErrText("");
            }
        }
        setShiftEnd(value);
    };

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(shiftName)) {
            formIsValid = false;
            setShiftNameErr(true);
            setShiftNameErrText("Shift Name is required");
        } else {
            setShiftNameErr(false);
            setShiftNameErrText("");
        }
        if (CommonConfig.isEmpty(shiftStart)) {
            formIsValid = false;
            setShiftStartErr(true);
            setShiftStartErrText("Shift start is required");
        } else {
            if (shiftStartErr) {
                formIsValid = false;
            } else {
                setShiftStartErr(false);
                setShiftStartErrText("");
            }
        }
        if (CommonConfig.isEmpty(shiftEnd)) {
            formIsValid = false;
            setShiftEndErr(true);
            setShiftEndErrText("Shift end is required");
        } else {
            if (shiftEndErr) {
                formIsValid = false;
            } else {
                setShiftEndErr(false);
                setShiftEndErrText("");
            }
        }
        return formIsValid;
    };

    const AddEditShiftMaster = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                let data = {
                    id: props.ID,
                    ShiftName: shiftName.trim().replace(/\s+/g, ' '),
                    ShiftStart: moment(shiftStart),
                    ShiftEnd: moment(shiftEnd),
                    CreatedBy: securityUserID,
                };
                await api
                    .post(APIConstant.path.AddUpdateShiftMaster, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                            // onCancel();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
        if (type === 'ShiftName') {
            setShiftName(alphanumericValue);
        }
    };

    return (
        <div className="p-d-flex p-flex-column p-jc-between">
            <div className='p-grid'>
                <div className="p-col-12 p-md-6">
                    <div className="custom-inputs">
                        <label htmlFor="clasName">Shift Name<span style={{ color: "red" }}>*</span></label>
                        <FloatLabel>
                            {/* <InputText
                                className="p-w-100"
                                id="className"
                                type="text"
                                placeholder="Shift Name"
                                maxLength={20}
                                value={shiftName}
                                autoFocus={true}
                                onChange={(e) => handleChange(e, 'ShiftName')}
                            /> */}
                            <InputText
                                ref={shiftNameRef}
                                className="p-w-100 p-mt-1"
                                id="className"
                                type="text"
                                placeholder="Shift Name"
                                maxLength={20}
                                value={shiftName}
                                autoFocus={true}
                                onChange={(e) => handleChange(e, 'ShiftName')}
                            />
                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {shiftNameErr ? shiftNameErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="shiftStart">Shift Start<span style={{ color: "red" }}>*</span></label>
                        <Calendar value={shiftStart} className='p-mt-1' onChange={(e) => handleStartChange(e.value)} hourFormat='12' timeOnly />
                        <span className="error-msg" style={{ color: 'red' }}>
                            {shiftStartErr ? shiftStartErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="shiftEnd">Shift End<span style={{ color: "red" }}>*</span></label>
                        <Calendar value={shiftEnd} className='p-mt-1' onChange={(e) => handleEndChange(e.value)} hourFormat='12' timeOnly onKeyDown={(e) => {
                            if (e.key === 'Tab' && !e.shiftKey) {
                                e.preventDefault();
                                if (submitButtonRef.current) {
                                    submitButtonRef.current.focus();
                                }
                            }
                        }} />
                        <span className="error-msg" style={{ color: 'red' }}>
                            {shiftEndErr ? shiftEndErrText : null}
                        </span>
                    </div>
                </div>
            </div>
            <div className='dialog-footer p-d-flex p-ai-center p-jc-end'>
                <Button className='p-m-0 btn-text-action-secondary' onClick={() => onCancel()}> cancel </Button>
                <Button ref={submitButtonRef} className='p-m-0 btn-text-action-primary p-m-1 submit-focus' label="Submit" severity="secondary" raised onClick={() => AddEditShiftMaster()} />
            </div>
        </div>
    );
};

export default AddEditShiftMasterDialog;